
jQuery(function($){
	/**
	 * Set cookieBar variables and run function
	 *
	 * https://github.com/kovarp/jquery.cookieBar
	 */
	
	/**
	 * Run functions
	 */
	blockSlider();
	rwdMenu();
    inifFancybox();
    loadMore();
    careerNav();
    libraryNav();
    footerNav();
    productGallery();
    productAsk();
    faq();
    register();
	login();
	passwordReminder();
	passwordChange();
	showPass();
	showPopup();
	handleContactForm7();

	function showPopup() {
		$('.show-popup').click(function(event) {
			event.preventDefault();
			jQuery('.popup').addClass('active');
		});
		$('.close-popup').click(function(event) {
			event.preventDefault();
			jQuery('.popup').removeClass('active');
		});
	}

	function showPass() {

		$('#all').change(function() {
            // Sprawdź, czy checkbox jest zaznaczony
            if ($(this).is(':checked')) {
                // Jeśli tak, zaznacz pozostałe checkboxy
                $('#rodo, #newsletter').prop('checked', true);
            } else {
                // Jeśli nie, odznacz pozostałe checkboxy
                $('#rodo, #newsletter').prop('checked', false);
            }
        });

        // Jeśli któryś z checkboxów "rodo" lub "newsletter" zostanie zmieniony
        $('#rodo, #newsletter').change(function() {
            // Sprawdź, czy oba checkboxy są zaznaczone
            if ($('#rodo').is(':checked') && $('#newsletter').is(':checked')) {
                // Jeśli tak, zaznacz checkbox "Zaznacz wszystkie"
                $('#all').prop('checked', true);
            } else {
                // Jeśli nie, odznacz checkbox "Zaznacz wszystkie"
                $('#all').prop('checked', false);
            }
        });

		$('#togglePassword').click(function(event) {
			event.preventDefault();
			let passwordField = $('#password');
			let fieldType = passwordField.attr('type');
			
			if (fieldType === 'password') {
				passwordField.attr('type', 'text');
				$(this).text('Ukryj hasło');
			} else {
				passwordField.attr('type', 'password');
				$(this).text('Pokaż hasło');
			}
		});

		$('#togglePassword2').click(function(event) {
			event.preventDefault();
			let passwordField = $('#password2');
			let fieldType = passwordField.attr('type');
			
			if (fieldType === 'password') {
				passwordField.attr('type', 'text');
				$(this).text('Ukryj hasło');
			} else {
				passwordField.attr('type', 'password');
				$(this).text('Pokaż hasło');
			}
		});
	}

  function toTranslate(string) {
		var s1 = $('.to-translate .s1').text();
		var s2 = $('.to-translate .s2').text();
		var s3 = $('.to-translate .s3').text();
		var s4 = $('.to-translate .s4').text();
		var s5 = $('.to-translate .s5').text();
		var s6 = $('.to-translate .s6').text();
		var s7 = $('.to-translate .s7').text();
		var s8 = $('.to-translate .s8').text();

		if (string == 's1') {
			return s1;
		}

		if (string == 's2') {
			return s2;
		}

		if (string == 's3') {
			return s3;
		}

		if (string == 's4') {
			return s4;
		}

		if (string == 's5') {
			return s5;
		}

		if (string == 's6') {
			return s6;
		}

		if (string == 's7') {
			return s7;
		}

		if (string == 's8') {
			return s8;
		}
	}

	function passwordChange() {
		$("form.password_change").validate({
			rules: {
				password: {
					required: true,
					pwcheck: true,
                    minlength: 8
				},
				password2: {
					required: true,
					pwcheck: true,
                    minlength: 8,
					equalTo: "#password"
				}
			},
			messages: {
				
				password: {
					required: toTranslate('s1'),
					pwcheck: toTranslate('s4'),
                    minlength: toTranslate('s3')
				},
				password2: {
					required: toTranslate('s1'),
					pwcheck: toTranslate('s4'),
                    minlength: toTranslate('s3'),
					equalTo: toTranslate('s2')
				},
			},
			submitHandler: function(form) {

				var password = $("form.password_change input[name=password]").val();
				var token = $("form.password_change input[name=token]").val();
				var user = $("form.password_change input[name=user]").val();
				var data = {
					action: 'password_change',
					token: token,
					user: user,
					password: password,
				};
				$('body').addClass('ajax-on');
				$.ajax({
				url: '/wp-admin/admin-ajax.php',
				data: data,
				method: 'POST',
				success: function (data) {
					
					if ('error' == data) {
						$('.message').hide();
						$('.error').show();
					}
					if ('success' == data) {
						$('form.password_change fieldset').slideUp(500);
						$('form .thank-you-message').slideDown(500);
					}
				},
				cache: false
				});
			}
		})

		$.validator.addMethod("pwcheck", function(value) {
			return /[a-z]/.test(value) // has a lowercase letter
				&& /\d/.test(value) // has a digit
		});
	};

	function passwordReminder() {
		$("form.password_reminder").validate({
			rules: {
				email: {
					required: true,
					email: true,
					remote: {
						url: ajax_object.ajax_url+'?action=check_if_email_in_db',
						type: "post",
						data: {

						  username: function() {
							return $( "#email" ).val();
						  }
						}
					}
				}
			},
			messages: {
				email: {
					required: toTranslate('s1'),
					email: toTranslate('s6'),
					remote: toTranslate('s5'),
				}
			},
			submitHandler: function(form) {

				var email = $("form.password_reminder input[name=email]").val();
				var data = {
					action: 'password_reminder',
					email: email
				};
				$('body').addClass('ajax-on');
				$.ajax({
				url: '/wp-admin/admin-ajax.php',
				data: data,
				method: 'POST',
				success: function (data) {
					
					data = JSON.parse(data);
					
					$('form.password_reminder fieldset').slideUp(500);
					$('form .thank-you-message').slideDown(500);
				},
				cache: false
				});
			}
		})

		$.validator.addMethod("pwcheck", function(value) {
			return /[a-z]/.test(value) // has a lowercase letter
				&& /\d/.test(value) // has a digit
		});

		$.validator.addMethod("emcheck", function(value) {

			var data = {
				action: 'check_if_email_exists',
				email: value,
			};
			$.ajax({
			url: ajax_object.ajax_url,
			data: data,
			method: 'POST',
			success: function (data) {
				console.log(data);
				return data;
			},
			cache: false
			});
		});
	};

	function login() {
		$("form.login").validate({
			rules: {
				email: {
					required: true,
					email: true,
				},
				password: {
					required: true,
				},
			
			},
			messages: {
				password: {
					required: toTranslate('s1'),
					
				},
				email: {
					required: toTranslate('s1'),
					email: toTranslate('s7'),
				}
			},
			submitHandler: function(form) {

				var email = $("form.login input[name=email]").val();
				var password = $("form.login input[name=password]").val();
				var refresh = $("form.login input[name=refresh]").val();
				var data = {
					action: 'login',
					email: email,
					password: password,
					refresh: refresh,
				};
				$('body').addClass('ajax-on');
				$.ajax({
				url: '/wp-admin/admin-ajax.php',
				data: data,
				method: 'POST',
				success: function (data) {
					if ('error' == data) {
						$('.message').hide();
						$('.error').show();
					}
					if ('inactive' == data) {
						$('.message').hide();
						$('.inactive').show();
					}
					if ('success' == data) {
						$('.message').hide();
						$('.success').show();
						location.reload();
					}
				},
				cache: false
				});
			}
		})

		$.validator.addMethod("pwcheck", function(value) {
			return /[a-z]/.test(value) // has a lowercase letter
				&& /\d/.test(value) // has a digit
		});

		$.validator.addMethod("emcheck", function(value) {

			var data = {
				action: 'check_if_email_exists',
				email: value,
			};
			$.ajax({
			url: ajax_object.ajax_url,
			data: data,
			method: 'POST',
			success: function (data) {
				console.log(data);
				return data;
			},
			cache: false
			});
		});
	};

	function register() {
		$("form.register").validate({
			rules: {
				email: {
					required: true,
					email: true,
					remote: {
						url: ajax_object.ajax_url+'?action=check_if_email_exists',
						type: "post",
						data: {
							username: function() {
								return $("#email").val();
							}
						}
					}
				},
				name: {
					required: true,
				},
				phone: {
					required: true,
					phonePLDE: true // Dodajemy nową regułę walidacji
				},
				password: {
					required: true,
					pwcheck: true,
					minlength: 8
				}
			},
			messages: {
				name: {
					required: toTranslate('s1'),
				},
				phone: {
					required: 'Numer telefonu jest wymagany.',
					phonePLDE: 'Wprowadź poprawny numer telefonu z Polski (+48) lub Niemiec (+49).'
				},
				password: {
					required: toTranslate('s1'),
					pwcheck: toTranslate('s4'),
					minlength: toTranslate('s3')
				},
				email: {
					required: toTranslate('s1'),
					email: toTranslate('s6'),
					remote: toTranslate('s8'),
				}
			},
			submitHandler: function(form) {
				var name = $("form.register input[name=name]").val();
				var phone = $("form.register input[name=phone]").val();
				var email = $("form.register input[name=email]").val();
				var company = $("form.register input[name=company]").val();
				var password = $("form.register input[name=password]").val();
				var region = $("form.register #region").val();
				var who = $("form.register #who").val();
				var newsletter = $("form.register #newsletter").val();
				var data = {
					action: 'register',
					name: name,
					phone: phone,
					email: email,
					company: company,
					password: password,
					newsletter: newsletter,
					who: who,
					region: region,
				};
				$('body').addClass('ajax-on');
				$.ajax({
					url: '/wp-admin/admin-ajax.php',
					data: data,
					method: 'POST',
					success: function (data) {
						data = JSON.parse(data);
						$('form.register fieldset').slideUp(500);
						$('form.register .top').hide();
						$('form .thank-you-message').slideDown(500);
					},
					cache: false
				});
			}
		});
		
		// Dodajemy niestandardową metodę walidacji dla numerów telefonów z Polski i Niemiec
		$.validator.addMethod("phonePLDE", function(value, element) {
			return this.optional(element) || 
				   /^(\+48\d{9}|\+49\d{10})$/.test(value);
		}, 'Wprowadź poprawny numer telefonu z Polski (+48) lub Niemiec (+49).');
		

		$.validator.addMethod("pwcheck", function(value) {
			return /[a-z]/.test(value) // has a lowercase letter
				&& /\d/.test(value) // has a digit
		});

		$.validator.addMethod("emcheck", function(value) {

			var data = {
				action: 'check_if_email_exists',
				email: value,
			};
			$.ajax({
			url: ajax_object.ajax_url,
			data: data,
			method: 'POST',
			success: function (data) {
				console.log(data);
				return data;
			},
			cache: false
			});
		});
	};

    function faq() {
      $('.show-answear').click(function(e) {
          e.preventDefault();
          var $this = $(this);
          $this.toggleClass('active');
          $this.next('.answear').slideToggle();
          $('.show-answear').not($this).removeClass('active').next('.answear').slideUp();
      });
    }

    function productAsk() {
        $('.product-ask').click(function(event) {
          event.preventDefault();
          var houseName = $(this).attr('data-txt');
          console.log(houseName);
          jQuery('#formularz textarea').val(houseName+'. ');
          jQuery('html, body').animate({
            scrollTop: jQuery('#formularz').offset().top
            }, 500);
        });
      }

    function productGallery() {

      $('.product-header__gallery .item').click(function(e){
        e.preventDefault();
        var newImageSrc = $(this).data('src');
		$('.product-header__main-photo').html('<a href="#"><img src=""></a>');
		$('.product-header__main-photo img').show();
        $('.product-header__main-photo img').attr('src', newImageSrc);
        $('.product-header__main-photo a').attr('href', newImageSrc);
        if ($(this).hasClass('d3')) {
            var newFileSrc = $(this).data('file');
			$('.product-header__main-photo img').hide();
            $('.product-header__main-photo').addClass('d3');
            $('.product-header__main-photo').append('<model-viewer style="width: 100%; height: 590px" camera-controls ar ar-modes="webxr scene-viewer quick-look"camera-orbit="-30deg 80deg 2.5m" src="'+newFileSrc+'" alt="lock"></model-viewer>');
        } else {
            $('.product-header__main-photo').removeClass('d3');
        }
      });
    }

    $('.cv-carousel').carouselVertical();

    function footerNav() {

      $('footer .menu-item-has-children > a').on('click', function(event) {
				event.preventDefault();
   
        	$(this).toggleClass('active');
				$(this).parent('li').children('ul').slideToggle(300);
			});

			$('.site-mobile-menu .menu-item-has-children > a').on('click', function(event) {
				event.preventDefault();
   
        	$(this).parent('li').toggleClass('active');
			$(this).parent('li').children('ul').slideToggle(300);
			});
    }

    function libraryNav() {
      // Obsługa kliknięcia na linki w nawigacji
      $('nav a').on('click', function(e) {
          e.preventDefault();
          var target = $(this).attr('href'); // Pobierz hash z linku
  
          // Dodaj klasę active do klikniętego linku i usuń ją z innych
          $('nav a').removeClass('active');
          $(this).addClass('active');
  
          // Ukryj wszystkie .library__group i pokaż tylko ten, którego ID pasuje do hashu
          $('.library__group').hide();
          $(target).show();
  
          // Zmień hash w adresie URL
          history.replaceState(null, null, target);
      });
  
      // Sprawdź, czy hash jest już ustawiony w adresie URL
      var hash = window.location.hash;
      if(hash) {
          var target = hash;
          $('nav a[href="' + target + '"]').addClass('active');
          $(target).show();
      } else {
          // Domyślnie ustaw pierwszy link jako aktywny i pierwszą .library__group jako widoczną
          $('nav a:first').addClass('active');
          $('.library__group:first').show();
      }
  }

    $(function(){
      loopcounter('myCountdown');
    });

    function careerNav() {

      $('.show-career').on('click',  function(event) {
        event.preventDefault();
        var href = $(this).attr('href');
        console.log(href);
        if($(this).hasClass('active')) {
          $(this).removeClass('active');
          $(href).slideUp(300);
          $(this).parent('article').children('div').removeClass('active');

        } else {
          $(this).addClass('active');
          $('.career-details').slideUp(300);
          $('.career-details'+href).slideDown(300);
          $(this).parent('article').children('div').addClass('active');
        }
        
      });
  
  
      $('.apply-job').on('click',  function(event) {
        event.preventDefault();
        var href = $(this).attr('data-pos');
        console.log(href);
        $('select[name=your-job] option[value="'+ href +'"]').attr('selected', 'selected');
        jQuery('html, body').animate({
          scrollTop: jQuery('#kariera').offset().top - 20
          }, 500);
      });
  
      $('.show-other-career').on('click',  function(event) {
        event.preventDefault();
        $('select[name=your-job] option:last').attr('selected', 'selected');
        jQuery('html, body').animate({
          scrollTop: jQuery('#kariera').offset().top - 20
          }, 500);
      });
    }
      

    function loadMore() {
      var page = 1; // Start from page 1
  
      $('#load-more-button').click(function() {
          page++;
  
          var data = {
              action: 'load_more_posts',
              page: page,
          };
  
          $.post('/wp-admin/admin-ajax.php', data, function(response) {
        console.log(response);
              if (response) {
                  $('#posts-container').append(response);
              } else {
                  $('#load-more-button').hide();
              }
          });
      });

      $('#load-more-button-kwowledge').click(function() {
        page++;

        var data = {
            action: 'load_more_knowledge',
            page: page,
        };

        $.post('/wp-admin/admin-ajax.php', data, function(response) {
      console.log(response);
            if (response) {
                $('#knowledge-container').append(response);
            } else {
                $('#load-more-button-kwowledge').hide();
            }
        });
    });
    }

    
  function inifFancybox() {
    Fancybox.bind('[data-fancybox], .wp-block-gallery a, a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".gif"] , a[href$=".webp"], .product-header__main-photo a', {
		Thumbs: false,
		loop : true,
		touch: false,
		dragToClose: false,
		dragHandle: '.fancybox-handle',

      afterClose: function(instance, current) {
        var videos = document.querySelectorAll('.inline-movies');

        // Loop through all videos with class 'inline-movies' and pause them
        videos.forEach(function(video) {
            video.pause();
        });
      }
		});
	  }
    
	function rwdMenu() {
		var windowWidth = $(document).width();

		$('#hamburger').click(function(event) {
			event.preventDefault();
			$(this).toggleClass('open');
			$('.site-mobile-menu').slideToggle(500);
			$('.site-header').toggleClass('menu-opened');
		});

		
	}

	(function () {
		var previousScroll = 0;
		
		$(window).scroll(function () {
			
			
			   var currentScroll = $(this).scrollTop();

			   if (currentScroll > 80) {
				   if (currentScroll > previousScroll){
					   $('header').addClass('fixed');
				   }
				   else {
					  $('header').removeClass('fixed');
				   }
				   previousScroll = currentScroll;
			   } else {
					   $('header').removeClass('fixed');
					$('header').removeClass('fixed');
			   }
	 });
		}());
        $(window).scroll(function() {   
            var windowWidth = $(window).width();
            var scroll = $(window).scrollTop();
    
            if (scroll >= 50 ) {
                $("header").addClass("scrolled");
           
            } else {
                $("header").removeClass("scrolled");
            }
    
        });

	function blockSlider() {
		

		

		jQuery('.header-slider').owlCarousel({
		  loop:true,
		  margin:0,
		  nav:true,
		  items:1,
		  autoplay:true,
		  autoplayTimeout:4000,
		  autoplaySpeed: 1700,
		  slideSpeed: 1700,
		  navSpeed: 1700,
		  dotsSpeed: 1700,
		  dots: true,
		  singleItem: true,
		  navText: ["<",">"],
      autoplayHoverPause:true
		  
		});

    jQuery('.products-category-slider-slider').owlCarousel({
		  loop:true,
		  margin:0,
		  nav:true,
		  items:1,
		  autoplay:true,
		  autoplayTimeout:4000,
		  autoplaySpeed: 1700,
		  slideSpeed: 1700,
		  navSpeed: 1700,
		  dotsSpeed: 1700,
		  dots: true,
		  singleItem: true,
		  navText: ["<",">"],
      autoplayHoverPause:true
		  
		});

    jQuery('.fp-offer-carousel').owlCarousel({
        loop:true,
        margin:20,
        nav:true,
        items:5,
        autoplay:true,
        autoplayTimeout:600,
        autoplaySpeed: 600,
        slideSpeed: 600,
        navSpeed: 600,
        dotsSpeed: 600,
        dots: true,
        singleItem: false,
        navText: ["<",">"],

        responsive:{
          0:{
            
            stagePadding: 0,
            items:2,
          },
          850:{
            items:3,
            stagePadding: 0,
          },
          1200:{
            items:5,
            stagePadding: 0,
          },
          
        }
      });

      jQuery('.fp-featured-carousel').owlCarousel({
        loop:false,
        margin:25,
        nav:true,
        items:5,
        autoplay:false,
        autoplayTimeout:600,
        autoplaySpeed: 600,
        slideSpeed: 600,
        navSpeed: 600,
        dotsSpeed: 600,
        dots: true,
        singleItem: false,
        navText: ["<",">"],

        responsive:{
          0:{
            
            stagePadding: 0,
            items:2,
          },
          850:{
            items:2,
            stagePadding: 0,
          },
          1200:{
            items:3,
            stagePadding: 0,
          },
          
        }
      });

      jQuery('.fp-portfolio-carousel').owlCarousel({
        loop:true,
        margin:25,
        nav:true,
        items:5,
        autoplay:false,
        autoplayTimeout:600,
        autoplaySpeed: 600,
        slideSpeed: 600,
        navSpeed: 600,
        dotsSpeed: 600,
        dots: true,
        singleItem: false,
        navText: ["<",">"],

        responsive:{
          0:{
            
            stagePadding: 0,
            items:1,
          },
          850:{
            items:2,
            stagePadding: 0,
          },
          1200:{
            items:3,
            stagePadding: 0,
          },
          
        }
      });

      jQuery('.gallery-carousel').owlCarousel({
        loop:false,
        margin:25,
        nav:true,
        items:5,
        autoplay:false,
        autoplayTimeout:600,
        autoplaySpeed: 600,
        slideSpeed: 600,
        navSpeed: 600,
        dotsSpeed: 600,
        dots: true,
        singleItem: false,
        navText: ["<",">"],

        responsive:{
          0:{
            
            stagePadding: 0,
            items:2,
          },
          850:{
            items:3,
            stagePadding: 0,
          },
          1200:{
            items:6,
            stagePadding: 0,
          },
          
        }
      });

      jQuery('.accessories-carousel').owlCarousel({
        loop:false,
        margin:25,
        nav:true,
        items:5,
        autoplay:false,
        autoplayTimeout:600,
        autoplaySpeed: 600,
        slideSpeed: 600,
        navSpeed: 600,
        dotsSpeed: 600,
        dots: true,
        singleItem: false,
        navText: ["<",">"],

        responsive:{
          0:{
            
            stagePadding: 0,
            items:1,
          },
          850:{
            items:2,
            stagePadding: 0,
          },
          1200:{
            items:3,
            stagePadding: 0,
          },
          
        }
      });

	  jQuery('.rewards-carousel').owlCarousel({
        loop:false,
        margin:25,
        nav:true,
        items:5,
        autoplay:false,
        autoplayTimeout:600,
        autoplaySpeed: 600,
        slideSpeed: 600,
        navSpeed: 600,
        dotsSpeed: 600,
        dots: true,
        singleItem: false,
        navText: ["<",">"],

        responsive:{
          0:{
            
            stagePadding: 0,
            items:1,
          },
          850:{
            items:2,
            stagePadding: 0,
          },
          1200:{
            items:3,
            stagePadding: 0,
          },

		  1400:{
            items:4,
            stagePadding: 0,
          },
          
        }
      });

	 }

	/**
	 * Handle Contact Form 7 submissions with spinner and button blocking
	 */
	function handleContactForm7() {
		
		// Flaga śledząca czy już inicjalizowaliśmy
		var initialized = false;
		
		// Funkcja znajdująca przycisk submit (różne warianty)
		function findSubmitButton(form) {
			// Sprawdź różne selektory używane przez CF7
			var button = form.querySelector('input[type="submit"]');
			if (!button) {
				button = form.querySelector('button[type="submit"]');
			}
			if (!button) {
				button = form.querySelector('.wpcf7-submit');
			}
			if (!button) {
				// Znajdź dowolny button w formularzu (domyślnie type="submit")
				var buttons = form.querySelectorAll('button');
				// Wyklucz buttony które NIE są submit (type="button" lub type="reset")
				for (var i = 0; i < buttons.length; i++) {
					var btn = buttons[i];
					var btnType = btn.getAttribute('type');
					// Jeśli nie ma type lub type="submit", to jest przycisk submit
					if (!btnType || btnType === 'submit') {
						button = btn;
						break;
					}
				}
			}
			return button;
		}
		
		// Funkcja dodająca spinner do formularza
		function addSpinnerToForm(form) {
			// Sprawdź czy formularz jest w DOM i ma przycisk submit
			if (!form || !form.parentNode) {
				return false;
			}
			
			const submitButton = findSubmitButton(form);
			if (!submitButton) {
				return false;
			}
			
			// Sprawdź czy spinner już nie został dodany
			if (form.querySelector('.wpcf7-spinner')) {
				return true;
			}
			
			// Dodaj position: relative do formularza (jeśli jeszcze nie ma)
			if (window.getComputedStyle(form).position === 'static') {
				form.style.position = 'relative';
			}
			
			// Utwórz element spinnera jako overlay
			const spinner = document.createElement('div');
			spinner.className = 'wpcf7-spinner';
		  spinner.innerHTML = '<span class="spinner-icon"></span>';
		
		// Dodaj spinner jako dziecko formularza (overlay)
		form.appendChild(spinner);
		
		// Dodaj event listener na kliknięcie przycisku
		submitButton.addEventListener('click', function(e) {
			// Sprawdź czy formularz jest już w trakcie wysyłania
			if (form.classList.contains('submitting')) {
				e.preventDefault();
				return false;
			}

		}, true); // Użyj capture phase
		
		return true;
	}
	
	// Funkcja inicjalizująca wszystkie formularze
	function initializeForms() {
		const forms = document.querySelectorAll('form.wpcf7-form');
		
		forms.forEach(function(form) {
			addSpinnerToForm(form);
		});
	}
	
	// Funkcja aktywująca spinner i blokującą formularz
	function activateSpinner(form) {
		const submitButton = findSubmitButton(form);
		const spinner = form.querySelector('.wpcf7-spinner');
		
		// Dodaj klasę submitting do formularza (opacity 0.5 będzie w CSS)
		form.classList.add('submitting');
		
		if (submitButton) {
			submitButton.disabled = true;
		} else {
			console.warn('CF7: Submit button not found when trying to activate spinner');
		}
		
		if (spinner) {
			spinner.classList.add('is-active');
		}
	}

	// Funkcja resetująca formularz do stanu normalnego
	function resetFormButton(form) {
		const submitButton = findSubmitButton(form);
		const spinner = form.querySelector('.wpcf7-spinner');
		
		// Usuń klasę submitting z formularza
		form.classList.remove('submitting');
		
		if (submitButton) {
			submitButton.disabled = false;
		}
		
		if (spinner) {
			spinner.classList.remove('is-active');
		}
	}

	// Obserwator DOM do wykrywania dynamicznie dodawanych formularzy
	var observer = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				mutation.addedNodes.forEach(function(node) {
					// Sprawdź czy dodany węzeł to formularz CF7
					if (node.nodeType === 1) { // Element node
						if (node.matches && node.matches('form.wpcf7-form')) {
							addSpinnerToForm(node);
						}
						// Sprawdź dzieci
						var forms = node.querySelectorAll && node.querySelectorAll('form.wpcf7-form');
						if (forms && forms.length > 0) {
							forms.forEach(addSpinnerToForm);
						}
					}
				});
			});
		});

		// Inicjalizacja po załadowaniu DOM
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', function() {
				// Poczekaj chwilę na załadowanie CF7
				setTimeout(initializeForms, 100);
				// Uruchom obserwator DOM
				observer.observe(document.body, {
					childList: true,
					subtree: true
				});
			});
		} else {
			// DOM już załadowany
			setTimeout(initializeForms, 100);
			observer.observe(document.body, {
				childList: true,
				subtree: true
			});
		}

		// Obsługa eventu wpcf7:init (gdy CF7 inicjalizuje formularz)
		document.addEventListener('wpcf7:init', function(event) {
			setTimeout(initializeForms, 50);
		});

		// Obsługa PRZED wysłaniem formularza
		document.addEventListener('wpcf7beforesubmit', function(event) {
			activateSpinner(event.target);
		}, false);

		// Alternatywna obsługa - submit event na formularzu
		document.addEventListener('submit', function(event) {
			var form = event.target;
			if (form.classList.contains('wpcf7-form')) {
				activateSpinner(form);
			}
		}, true); // Use capture phase

		// Obsługa zakończenia wysyłki - wszystkie przypadki
		document.addEventListener('wpcf7submit', function(event) {
			resetFormButton(event.target);
		}, false);

		// Dodatkowa obsługa dla sukcesu
		document.addEventListener('wpcf7mailsent', function(event) {
			resetFormButton(event.target);
		}, false);

		// Dodatkowa obsługa dla błędu
		document.addEventListener('wpcf7mailfailed', function(event) {
			resetFormButton(event.target);
		}, false);

		// Obsługa błędów walidacji
		document.addEventListener('wpcf7invalid', function(event) {
			resetFormButton(event.target);
		}, false);

		// Obsługa wykrycia spamu
		document.addEventListener('wpcf7spam', function(event) {
			resetFormButton(event.target);
		}, false);
	}

})